<div class="search-advanced-items" id="outro">

  @if (filterResetWarning) {
    <div class="row row-total row-justify-content-left">
      <div class="info" style="position: relative;">
        <h2 class="info-title">Heads up! <strong>Your previously stored filter was reset!</strong></h2>
        Due to a breaking change in the structure of the filter, your previously stored filter could not be reloaded.
        Please revise all settings. You can copy any 'Free-text Rules' from your current filter file. We apologize for this inconvenience.
        <div class="close-info-btn" (click)="filterResetWarning = false">✕</div>
      </div>
    </div>
  }

  @if (showQuickFiltersMainTabBanner) {
    <div class="info box reset-font" style="margin-bottom: 12px;">
      <div class="info-box-body">
        <div class="close-info-btn" (click)="dismissQuickFiltersMainTabBanner()">✕</div>
          We noticed you often use the Quick Filters tab. <a class="action-link" (click)="enableQuickFiltersAsMainTab()">Click here</a> to make this the main tab on future site visits.
          <a class="remove-warning-link" (click)="dismissQuickFiltersMainTabBanner()">(no thanks, keep opening on the Presets tab)</a>
      </div>
    </div>
  }

  <app-tutorial-step [noSteps]="true" [center]="true" [tutorialStep]="'intro'" [title]="'Quick Filter Tutorial'" [largeTitle]="true"
    [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
    (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

    <div class="tutorial-options">
      <div class="tutorial-option" (click)="nextTutorialStep($event)">
        <h3>Take a Tour</h3>
        We'll guide you through the different sections of the Quick Filter tab.
      </div>

      <div class="tutorial-option" (click)="dismissTutorial($event)">
        <h3>I Got This</h3>
        You can always read the <span class="extra-info">(?)</span> signs for more information, or take this tutorial later.
      </div>
    </div>

    <p class="extra-info link-game-text">
      @if (poe1) {
        <img src="/img/logo-poe2-small.webp" class="link-game-logo"/>
        Looking for a <strong>Path of Exile 2</strong> filter?
        Visit <a href="https://poe2filter.com" (click)="stopPropagation($event)">poe2filter.com</a> instead.
      } @else {
        <img src="/img/logo-poe1-small.webp" class="link-game-logo"/>
        Looking for a <strong>Path of Exile 1</strong> filter?
        Visit <a href="https://poe1filter.com" (click)="stopPropagation($event)">poe1filter.com</a> instead.
      }
    </p>
  </app-tutorial-step>
  <div class="search-advanced-pane blue">
    <div class="quick-filters-section filter-section" id="league-start" data-section-id="leagueStart">
      <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['filter-structure', 'league-start']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

      <app-tutorial-step [right]="true" [tutorialStep]="'filter-structure'" [title]="'Quick Filter Structure'"
        [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
        (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

        <app-content cid="filter-structure"></app-content>
      </app-tutorial-step>

      <app-tutorial-step [right]="true" [tutorialStep]="'league-start'" [title]="poe1 ? 'League Start' : 'Campaign'"
        [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
        (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

        <app-content cid="league-start">
        </app-content>
      </app-tutorial-step>

      <div class="section-title-container">
        <h2 class="section-title gradient-title text-align-center" (click)="filter.sectionVisibility.leagueStart = !filter.sectionVisibility.leagueStart; updateFilter();">
          {{ poe1 ? 'League Start' : 'Campaign' }}

          <span class="input-group-btn">
            <button class="btn toggle-btn caret-btn" [class.off]="!filter.sectionVisibility.leagueStart"></button>
          </span>

          <span class="icon icon-question" (mouseenter)="showLevelingAndCampaignHelpText = true" (mouseleave)="showLevelingAndCampaignHelpText = false"></span>
        </h2>
      </div>

      <div class="quick-filters-section-help-container" [class.visible]="showLevelingAndCampaignHelpText">
        <div class="quick-filters-section-help-text">
          <p>
            Show and highlight items specifically useful throughout the campaign and early maps{{ poe1 ? ', and items to vendor at NPC\'s for Currency' : ', and items to salvage for Currency' }}.
          </p>
        </div>
      </div>

      <div class="quick-filters-section-summary" [class.collapsed]="filter.sectionVisibility.leagueStart">
        {{ activeRules.levelingFilters + (poe1 ? activeRules.vendorRecipeFiltersPoe1 : activeRules.salvagingGearFiltersPoe2) }} active rules
      </div>

      <div class="quick-filters-section-body" [class.collapsed]="!filter.sectionVisibility.leagueStart">
        <app-leveling-filters [filter]="filter" [activeRules]="activeRules"></app-leveling-filters>
        @if (poe1) {
          <app-vendor-recipe-filters-poe1 [filter]="filter" [activeRules]="activeRules"></app-vendor-recipe-filters-poe1>
        } @else {
          <app-salvaging-gear-filters-poe2 [filter]="filter" [activeRules]="activeRules"></app-salvaging-gear-filters-poe2>
        }
      </div>
    </div>

    <div class="quick-filters-section filter-section" data-section-id="currency">
      <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['currency']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

      <app-tutorial-step [right]="true" [tutorialStep]="'currency'" [title]="'Currency'"
        [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
        (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

        <app-content cid="currency"></app-content>
      </app-tutorial-step>

      <div class="section-title-container">
        <h2 class="section-title gradient-title text-align-center" (click)="filter.sectionVisibility.currency = !filter.sectionVisibility.currency; updateFilter();">
          Currency

          <span class="input-group-btn">
            <button class="btn toggle-btn caret-btn" [class.off]="!filter.sectionVisibility.currency"></button>
          </span>

          <span class="icon icon-question" (mouseenter)="showCurrencyHelpText = true" (mouseleave)="showCurrencyHelpText = false"></span>
        </h2>
      </div>

      <div class="quick-filters-section-help-container" [class.visible]="showCurrencyHelpText">
        <div class="quick-filters-section-help-text">
          <p>
            Configure which Currency to show, how to divide them into tiers, and how to handle stacks of currency and gold.
          </p>
        </div>
      </div>

      <div class="quick-filters-section-summary" [class.collapsed]="filter.sectionVisibility.currency">
        {{ activeRules.favouriteCurrencyFilters + activeSpecialRules.favouriteCurrencyTypes + activeRules.currencyFilters + activeSpecialRules.currencyStackSettings }} active rules
      </div>

      <div class="quick-filters-section-body" [class.collapsed]="!filter.sectionVisibility.currency">
        <app-currency-filters [filter]="filter" [activeRules]="activeRules" [activeSpecialRules]="activeSpecialRules"></app-currency-filters>
      </div>
    </div>

    <div class="quick-filters-section filter-section" data-section-id="uniques">
      <div class="section-title-container">
        <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['uniques']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

        <h2 class="section-title gradient-title text-align-center" (click)="filter.sectionVisibility.uniques = !filter.sectionVisibility.uniques; updateFilter();">
          Uniques & Chance Bases

          <span class="input-group-btn">
            <button class="btn toggle-btn caret-btn" [class.off]="!filter.sectionVisibility.uniques"></button>
          </span>

          <span class="icon icon-question" (mouseenter)="showUniquesAndOtherHelpText = true" (mouseleave)="showUniquesAndOtherHelpText = false"></span>
        </h2>
      </div>

      <div class="quick-filters-section-help-container" [class.visible]="showUniquesAndOtherHelpText">
        <div class="quick-filters-section-help-text">
          <p>
            Decide which Unique items to highlight.
          </p>
        </div>
      </div>

      <div class="quick-filters-section-summary" [class.collapsed]="filter.sectionVisibility.uniques">
        <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['uniques']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>
        {{ activeRules.specialUniqueFilters + activeSpecialRules.valuableUniqueFilters + activeSpecialRules.remainingUniqueFilters + activeSpecialRules.chanceBaseFilters }} active rules
      </div>

      <div class="quick-filters-section-body" [class.collapsed]="!filter.sectionVisibility.uniques">
        <div class="tutorial-section" id="uniques">
          <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['uniques']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

          <app-tutorial-step [right]="true" [tutorialStep]="'uniques'" [title]="'Uniques'"
            [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
            (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

            <app-content cid="uniques"></app-content>
          </app-tutorial-step>

          <app-unique-filters [filter]="filter" [activeRules]="activeRules" [activeSpecialRules]="activeSpecialRules"></app-unique-filters>
        </div>
      </div>
    </div>

    <div class="quick-filters-section filter-section" data-section-id="other">
      <div class="section-title-container">
        <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['uniques']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

        <h2 class="section-title gradient-title text-align-center" (click)="filter.sectionVisibility.other = !filter.sectionVisibility.other; updateFilter();">
          Other Items

          <span class="input-group-btn">
            <button class="btn toggle-btn caret-btn" [class.off]="!filter.sectionVisibility.other"></button>
          </span>

          <span class="icon icon-question" (mouseenter)="showUniquesAndOtherHelpText = true" (mouseleave)="showUniquesAndOtherHelpText = false"></span>
        </h2>
      </div>

      <div class="quick-filters-section-help-container" [class.visible]="showUniquesAndOtherHelpText">
        <div class="quick-filters-section-help-text">
          <p>
            Decide which other items to highlight, like Quest Items and League-specific items{{ poe1 ? ', and which Skill Gems and Maps to show' : ''}}.
          </p>
        </div>
      </div>

      <div class="quick-filters-section-summary" [class.collapsed]="filter.sectionVisibility.other">
        <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['uniques']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>
        {{ activeRules.gemFiltersPoe1 + activeRules.mapFiltersPoe1 + activeRules.otherItemFilters }} active rules
      </div>

      <div class="quick-filters-section-body" [class.collapsed]="!filter.sectionVisibility.other">
        @if (poe1) {
          <div class="tutorial-section" id="skill-gems">
            <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['skill-gems']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

            <app-tutorial-step [right]="true" [tutorialStep]="'skill-gems'" [title]="'Skill Gems'"
              [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
              (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

              <app-content cid="skill-gems"
                [conditions]="{
                  earlyCampaignProgress: filter.progressPreset === 'presetEarlyCampaign1' || filter.progressPreset === 'presetMidCampaign30'
                }">
              </app-content>
            </app-tutorial-step>

            <app-gem-filters-poe1 [filter]="filter" [activeRules]="activeRules"></app-gem-filters-poe1>
          </div>

          <div class="tutorial-section" id="maps">
            <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['maps']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

            <app-tutorial-step [right]="true" [tutorialStep]="'maps'" [title]="'Maps'"
              [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
              (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

              <app-content cid="maps"></app-content>
            </app-tutorial-step>

            <app-map-filters-poe1
              [filter]="filter"
              [dynamicWaystoneThresholds]="dynamicWaystoneThresholds"
              [activeRules]="activeRules"
            ></app-map-filters-poe1>
          </div>
        }

        <div class="tutorial-section" id="other-items">
          <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['other-items']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

          <app-tutorial-step [right]="true" [tutorialStep]="'other-items'" [title]="'Other Items'"
            [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
            (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

            <app-content cid="other-items"></app-content>
          </app-tutorial-step>
          <app-other-item-filters [filter]="filter" [activeRules]="activeRules" [activeSpecialRules]="activeSpecialRules"></app-other-item-filters>
        </div>
      </div>
    </div>
  </div>

  <div class="search-advanced-pane blue">
    <div class="quick-filters-section filter-section" id="my-equipment" data-section-id="myEquipment">
      <app-tutorial-step [left]="true" [arrowUp]="true" [tutorialStep]="'outro'" [title]="'Tier Lists, Custom Rules & Customize Styles'"
        [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
        (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

        <app-content cid="outro">
        </app-content>

      </app-tutorial-step>

      <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['my-equipment', 'my-equipment-highlights']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

      <app-tutorial-step [left]="true" [tutorialStep]="'my-equipment'" [title]="'Favourite Equipment'"
        [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
        (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

        <app-content cid="my-equipment"
          [conditions]="{
            classPreset: filter.classPreset,
            noClassPreset: !filter.classPreset,
            poe1AndShowLevelingGear: filter.showLevelingGear
          }">
        </app-content>
      </app-tutorial-step>

      <app-tutorial-step [left]="true" [tutorialStep]="'my-equipment-highlights'" [title]="'Favourite Equipment Variants'"
        [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
        (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

        <app-content cid="my-equipment-highlights">
        </app-content>
      </app-tutorial-step>

      <div class="section-title-container">
        <h2 class="section-title gradient-title text-align-center" (click)="filter.sectionVisibility.myEquipment = !filter.sectionVisibility.myEquipment; updateFilter();">
          Favourite Equipment

          <span class="input-group-btn">
            <button class="btn toggle-btn caret-btn" [class.off]="!filter.sectionVisibility.myEquipment"></button>
          </span>

          <span class="icon icon-question" (mouseenter)="showMyEquipmentHelpText = true" (mouseleave)="showMyEquipmentHelpText = false"></span>
        </h2>
      </div>

      <div class="quick-filters-section-help-container" [class.visible]="showMyEquipmentHelpText">
        <div class="quick-filters-section-help-text">
          <p>
            Select the weapon types, armour pieces, jewellery, jewels{{ poe1 ? ', flasks and tinctures' : ', flasks and charms' }} that your character uses or you want to track in particular. For each of them, the filter can highlight {{ poe2 ? 'Unidentified Tiered and Exceptional versions or other interesting Crafting Bases' : 'good Crafting Bases, 6-Linked versions, or items with a lot of Memory Strands' }} — you can configure which ones you're interested in. You can change the Equipment Tier for each type of highlight, here, or on the <a href="/tier-list/gear"><span class="icon icon-list-numbered"></span> Equipment Tier List</a> tab.
          </p>
          <p>
            Aside from this equipment that you're looking for in particular, in the 'Other Equipment' section below you can configure general rules for valuable equipment, to trade or use for other characters.
          </p>
        </div>
      </div>

      <div class="quick-filters-section-summary" [class.collapsed]="filter.sectionVisibility.myEquipment">
        {{ activeSpecialRules.weaponExceptions + activeSpecialRules.armourExceptions + activeSpecialRules.jewelleryExceptions + activeSpecialRules.jewelExceptions + activeSpecialRules.flaskExceptions }} active rules
      </div>

      <div class="quick-filters-section-body" [class.collapsed]="!filter.sectionVisibility.myEquipment" id="stepWeaponExceptions">
        <app-my-weapons-list [filter]="filter" [activeSpecialRules]="activeSpecialRules"></app-my-weapons-list>

        <app-my-armour-list [filter]="filter" [activeSpecialRules]="activeSpecialRules"></app-my-armour-list>

        <app-my-jewellery-list [filter]="filter" [activeSpecialRules]="activeSpecialRules"></app-my-jewellery-list>

        <app-my-jewels-list [filter]="filter" [activeSpecialRules]="activeSpecialRules"></app-my-jewels-list>

        <app-my-flasks-list [filter]="filter" [activeSpecialRules]="activeSpecialRules"></app-my-flasks-list>
      </div>
    </div>

    <div class="quick-filters-section filter-section" id="other-equipment" data-section-id="otherEquipment">
      <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['other-equipment']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

      <app-tutorial-step [left]="true" [tutorialStep]="'other-equipment'" [title]="'Other Equipment'"
        [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
        (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

        <app-content cid="other-equipment">
        </app-content>
      </app-tutorial-step>

      <div class="section-title-container">
        <h2 class="section-title gradient-title text-align-center" (click)="filter.sectionVisibility.otherEquipment = !filter.sectionVisibility.otherEquipment; updateFilter();">
          Other Equipment

          <span class="input-group-btn">
            <button class="btn toggle-btn caret-btn" [class.off]="!filter.sectionVisibility.otherEquipment"></button>
          </span>

          <span class="icon icon-question" (mouseenter)="showOtherEquipmentHelpText = true" (mouseleave)="showOtherEquipmentHelpText = false"></span>
        </h2>
      </div>

      <div class="quick-filters-section-help-container" [class.visible]="showOtherEquipmentHelpText">
        <div class="quick-filters-section-help-text">
          <p>
            Configure which other potentially valuable or useful equipment to show or highlight; to trade or use for other characters. {{ poe1 ? 'Influenced Gear, Special Gear' : 'Unidentified Tiered Gear, Exceptional Gear' }}, Identified Items and Crafting Bases.
          </p>
        </div>
      </div>

      <div class="quick-filters-section-summary" [class.collapsed]="filter.sectionVisibility.otherEquipment">
        {{ activeRules.unidentifiedEquipmentFiltersPoe2 + activeRules.specialEquipmentFiltersPoe2 + activeRules.influencedGearFiltersPoe1 + activeRules.influencedJewelleryFiltersPoe1 + activeRules.identifiedItemFilters
          + activeRules.craftingBaseFiltersPoe1 + activeRules.craftingBaseFiltersPoe2 }} active rules
      </div>

      <div class="quick-filters-section-body" [class.collapsed]="!filter.sectionVisibility.otherEquipment">
        @if (poe1) {
          <app-influenced-gear-filters-poe1 [filter]="filter" [activeRules]="activeRules"></app-influenced-gear-filters-poe1>

          <app-influenced-jewellery-filters-poe1 [filter]="filter" [activeRules]="activeRules" [activeSpecialRules]="activeSpecialRules"></app-influenced-jewellery-filters-poe1>

          <app-identified-item-filters [filter]="filter" [activeRules]="activeRules" [activeSpecialRules]="activeSpecialRules"></app-identified-item-filters>

          <app-crafting-base-filters-poe1 [filter]="filter" [activeRules]="activeRules" [activeSpecialRules]="activeSpecialRules"></app-crafting-base-filters-poe1>
        } @else {
          <app-unidentified-equipment-filters-poe2 [filter]="filter" [activeRules]="activeRules"></app-unidentified-equipment-filters-poe2>

          <app-identified-item-filters [filter]="filter" [activeRules]="activeRules" [activeSpecialRules]="activeSpecialRules"></app-identified-item-filters>

          <app-crafting-base-filters-poe2 [filter]="filter" [activeRules]="activeRules" [activeSpecialRules]="activeSpecialRules"></app-crafting-base-filters-poe2>

          <app-special-equipment-filters-poe2 [filter]="filter" [activeRules]="activeRules"></app-special-equipment-filters-poe2>
        }
      </div>
    </div>

    <div class="quick-filters-section filter-section" id="remaining-equipment" data-section-id="remainingEquipment">
      <div app-tutorial-section-hider [tutorialComplete]="tutorialComplete" [tutorialSteps]="['remaining-equipment']" [currentTutorialStep]="currentTutorialStep" (dismissOrNextTutorialStepEmitter)="dismissOrNextTutorialStep()"></div>

      <app-tutorial-step [left]="true" [tutorialStep]="'remaining-equipment'" [title]="'Remaining Equipment'"
        [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
        (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

        <app-content cid="remaining-equipment"></app-content>
      </app-tutorial-step>

      <div class="section-title-container">
        <h2 class="section-title gradient-title text-align-center" (click)="filter.sectionVisibility.remainingEquipment = !filter.sectionVisibility.remainingEquipment; updateFilter();">
          Remaining Equipment

          <span class="input-group-btn">
            <button class="btn toggle-btn caret-btn" [class.off]="!filter.sectionVisibility.remainingEquipment"></button>
          </span>

          <span class="icon icon-question" (mouseenter)="showRemainingEquipmentHelpText = true" (mouseleave)="showRemainingEquipmentHelpText = false"></span>
        </h2>
      </div>

      <div class="quick-filters-section-help-container" [class.visible]="showRemainingEquipmentHelpText">
        <div class="quick-filters-section-help-text">
          <p>
            Specify what to do with any equipment which is not selected by any of the above filters: hide it all, or by Rarity, Gear Tier, or Item Level.
          </p>
        </div>
      </div>

      <div class="quick-filters-section-summary" [class.collapsed]="filter.sectionVisibility.remainingEquipment">
        {{ activeRules.remainingGearFilters + activeRules.remainingJewelleryFilters + activeRules.remainingFlaskCharmFilters }} active rules
      </div>

      <div class="quick-filters-section-body" [class.collapsed]="!filter.sectionVisibility.remainingEquipment">
        <app-remaining-equipment-filters [filter]="filter" [activeRules]="activeRules"></app-remaining-equipment-filters>
      </div>
    </div>
  </div>
</div>

<app-tutorial-step [center]="true" [bottom]="true" [arrowDown]="true" [tutorialStep]="'filter-output'" [title]="'Filter Output'"
  [tutorialComplete]="tutorialComplete" [currentTutorialStep]="currentTutorialStep" [currentTutorialStepIndex]="currentTutorialStepIndex" [totalTutorialSteps]="totalTutorialSteps"
  (dismissTutorialEmitter)="dismissTutorial()" (nextTutorialStepEmitter)="nextTutorialStep()" (previousTutorialStepEmitter)="previousTutorialStep()">

  <app-content cid="filter-output"></app-content>
</app-tutorial-step>
